/**
 * @generated SignedSource<<e2da5622fdd1e9bb935c41e9cbff0410>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RulesDeliveryMethodQuery$variables = Record<PropertyKey, never>;
export type RulesDeliveryMethodQuery$data = {
  readonly project: {
    readonly id: string;
    readonly uuid: any;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JiraAssignee_accountTagKeys" | "JiraAssignee_accountTagValues" | "JiraAssignee_resourceTagKeys" | "JiraAssignee_whoami" | "JiraGrouping_tagKeys" | "JiraInstance_jiraInstances">;
};
export type RulesDeliveryMethodQuery = {
  response: RulesDeliveryMethodQuery$data;
  variables: RulesDeliveryMethodQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "default"
    }
  ],
  "concreteType": "Project",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/)
  ],
  "storageKey": "project(name:\"default\")"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v4/*:: as any*/),
  (v0/*:: as any*/),
  (v5/*:: as any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  "filterElement"
],
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ResourceTagKeyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResourceTagKey",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v6/*:: as any*/),
        "storageKey": null
      },
      (v7/*:: as any*/)
    ],
    "storageKey": null
  },
  (v8/*:: as any*/)
],
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RulesDeliveryMethodQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JiraAssignee_accountTagKeys"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JiraAssignee_accountTagValues"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JiraAssignee_resourceTagKeys"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JiraAssignee_whoami"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JiraGrouping_tagKeys"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "JiraInstance_jiraInstances"
      },
      (v2/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RulesDeliveryMethodQuery",
    "selections": [
      {
        "alias": "jiraAssigneeAccountTagKeys",
        "args": (v3/*:: as any*/),
        "concreteType": "AccountTagKeyConnection",
        "kind": "LinkedField",
        "name": "accountTagKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountTagKeyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountTagKey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v6/*:: as any*/),
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "accountTagKeys(first:100)"
      },
      {
        "alias": "jiraAssigneeAccountTagKeys",
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "JiraAssignee__jiraAssigneeAccountTagKeys",
        "kind": "LinkedHandle",
        "name": "accountTagKeys"
      },
      {
        "alias": "jiraAssigneeAccountTagValues",
        "args": (v3/*:: as any*/),
        "concreteType": "AccountTagValueConnection",
        "kind": "LinkedField",
        "name": "accountTagValues",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountTagValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountTagValue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  },
                  (v0/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "accountTagValues(first:100)"
      },
      {
        "alias": "jiraAssigneeAccountTagValues",
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "JiraAssignee__jiraAssigneeAccountTagValues",
        "kind": "LinkedHandle",
        "name": "accountTagValues"
      },
      {
        "alias": "jiraAssigneeResourceTagKeys",
        "args": (v3/*:: as any*/),
        "concreteType": "ResourceTagKeyConnection",
        "kind": "LinkedField",
        "name": "resourceTagKeys",
        "plural": false,
        "selections": (v10/*:: as any*/),
        "storageKey": "resourceTagKeys(first:100)"
      },
      {
        "alias": "jiraAssigneeResourceTagKeys",
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "JiraAssignee__jiraAssigneeResourceTagKeys",
        "kind": "LinkedHandle",
        "name": "resourceTagKeys"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "jiraGroupingTagKeys",
        "args": (v3/*:: as any*/),
        "concreteType": "ResourceTagKeyConnection",
        "kind": "LinkedField",
        "name": "resourceTagKeys",
        "plural": false,
        "selections": (v10/*:: as any*/),
        "storageKey": "resourceTagKeys(first:100)"
      },
      {
        "alias": "jiraGroupingTagKeys",
        "args": (v3/*:: as any*/),
        "filters": (v9/*:: as any*/),
        "handle": "connection",
        "key": "JiraGrouping__jiraGroupingTagKeys",
        "kind": "LinkedHandle",
        "name": "resourceTagKeys"
      },
      {
        "alias": null,
        "args": (v11/*:: as any*/),
        "concreteType": "JiraInstanceConnection",
        "kind": "LinkedField",
        "name": "jiraInstances",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraInstanceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraInstance",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*:: as any*/),
                  (v12/*:: as any*/),
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "issueLimitSoft",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "issueLimitHard",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraSpace",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": true,
                    "selections": [
                      (v4/*:: as any*/),
                      (v12/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JiraWorkType",
                        "kind": "LinkedField",
                        "name": "workTypes",
                        "plural": true,
                        "selections": [
                          (v12/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "iconUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraSpace",
                    "kind": "LinkedField",
                    "name": "defaultSpace",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/),
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraWorkType",
                    "kind": "LinkedField",
                    "name": "defaultWorkType",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": "jiraInstances(first:50)"
      },
      {
        "alias": null,
        "args": (v11/*:: as any*/),
        "filters": null,
        "handle": "connection",
        "key": "JiraInstance__jiraInstances",
        "kind": "LinkedHandle",
        "name": "jiraInstances"
      },
      (v2/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "c69ac3aa4a150f1381a1228fe1ff5296",
    "id": null,
    "metadata": {},
    "name": "RulesDeliveryMethodQuery",
    "operationKind": "query",
    "text": "query RulesDeliveryMethodQuery {\n  ...JiraAssignee_accountTagKeys\n  ...JiraAssignee_accountTagValues\n  ...JiraAssignee_resourceTagKeys\n  ...JiraAssignee_whoami\n  ...JiraGrouping_tagKeys\n  ...JiraInstance_jiraInstances\n  project(name: \"default\") {\n    id\n    uuid\n  }\n}\n\nfragment JiraAssignee_accountTagKeys on Query {\n  jiraAssigneeAccountTagKeys: accountTagKeys(first: 100) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JiraAssignee_accountTagValues on Query {\n  jiraAssigneeAccountTagValues: accountTagValues(first: 100) {\n    edges {\n      node {\n        value\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JiraAssignee_resourceTagKeys on Query {\n  jiraAssigneeResourceTagKeys: resourceTagKeys(first: 100) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JiraAssignee_whoami on Query {\n  whoami {\n    email\n  }\n}\n\nfragment JiraGrouping_tagKeys on Query {\n  jiraGroupingTagKeys: resourceTagKeys(first: 100) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment JiraInstance_jiraInstances on Query {\n  jiraInstances(first: 50) {\n    edges {\n      node {\n        id\n        name\n        uuid\n        url\n        username\n        clientId\n        issueLimitSoft\n        issueLimitHard\n        spaces {\n          key\n          name\n          workTypes {\n            name\n            iconUrl\n          }\n        }\n        defaultSpace {\n          key\n          name\n        }\n        defaultWorkType {\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "19897ca891b103511fe3665dc91e5f93";

export default node;
